
import { ApolloProvider } from '@apollo/client'
import { useAuth0 } from '@auth0/auth0-react'
import type { IdToken } from '@auth0/auth0-react'
import { useRedirect } from '@mbfab/frontend-common'
import { useEffect, useState } from 'react'

import { Loading } from '../components/ui/Loading'
import { routes } from '../config/routes'
import { useApolloClient } from '../services/apollo_client'
import { getTenantIdFromPath } from '../util'

const Body = ({ token, children }: { token: string; children: React.ReactElement }) => {
  const client = useApolloClient({ token, tenantId: getTenantIdFromPath() })

  if (client === undefined) {
    return <></>
  }

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

const AuthenticatedAuth0ApolloProvider = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated, isLoading, getAccessTokenSilently, getIdTokenClaims } = useAuth0()
  const redirect = useRedirect()
  const [idToken, setIdToken] = useState<IdToken>()

  // TODO
  // useEffect(() => {
  //   if (idToken === undefined) {
  //     return
  //   }

  //   localStorage.setItem(
  //     CONSTANT.localStorageKey.PARTIAL_AUTH0_RESPONSE,
  //     JSON.stringify({
  //       email: idToken.email,
  //       email_verified: idToken.email_verified,
  //       exp: idToken.exp,
  //       updated_at: idToken.updated_at,
  //       family_name: idToken.family_name,
  //       given_name: idToken.given_name,
  //       name: idToken.name,
  //       nickname: idToken.nickname,
  //       sub: (idToken as unknown as { sub: string }).sub,
  //     }),
  //   )
  // }, [idToken])

  useEffect(() => {
    const f = async () => {
      if (isAuthenticated) {
        const token = await getAccessTokenSilently()
        const idToken = await getIdTokenClaims()
        setIdToken(idToken)
      }
    }
    void f()
  }, [isAuthenticated, isLoading])

  if (isLoading) {
    return <Loading message={`認証中...`} />
  }

  if (!isAuthenticated) {
    // logger.debug(`Authentication failed on Auth0. Redirect to /sign_in from ${location.href}`)

    redirect(routes.signInPath())
    return <Loading message={`認証できませんでした。リダイレクト中...`} />
  }

  if (idToken?.__raw === undefined) {
    return <Loading message={`アクセストークンの取得中...`} />
  }

  return <Body token={idToken.__raw}>{children}</Body>
}

export const AuthenticatedApolloProvider = ({ children }: { children: React.ReactElement }) => {
  // TODO
  // const { token } = useSalescoreAuth()
  // if (isPresent(token)) {
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   return <Body token={token}>{children as any}</Body>
  // }

  return <AuthenticatedAuth0ApolloProvider>{children}</AuthenticatedAuth0ApolloProvider>
}
